import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Lock, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { getVisitorId } from "@/lib/tracker";
import { CONSENT_TEXT } from "@/config";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";

export const LeadForm = ({ profil, score }) => {
  const [form, setForm] = useState({ prenom: "", telephone: "", courriel: "" });
  const [consent, setConsent] = useState(false);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.prenom.trim()) return toast.error("Votre prénom est requis.");
    if (!form.courriel.trim() && !form.telephone.trim()) return toast.error("Un courriel ou un téléphone est requis.");
    if (!consent) return toast.error("Le consentement est requis (Loi 25).");
    setSending(true);
    try {
      await api.createLead({ ...form, consentement: true, consentement_texte: CONSENT_TEXT, profil, score, visitor_id: getVisitorId() });
      setDone(true);
      toast.success("Merci ! Vos informations sont enregistrées en toute confidentialité.");
    } catch (err) {
      toast.error("Une erreur est survenue. Réessayez.");
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <div data-testid="lead-form-success" className="rounded-2xl bg-[#012141] text-white p-6 text-center">
        <ShieldCheck className="mx-auto mb-2" size={28} style={{ color: "#C89A3E" }} />
        <p className="font-semibold">C'est noté, {form.prenom}. On vous contactera rapidement.</p>
      </div>
    );
  }

  return (
    <form data-testid="lead-form" onSubmit={submit} className="rounded-2xl border border-[#012141]/15 bg-white p-6 shadow-sm text-left">
      <h3 className="font-heading text-lg font-bold text-[#012141]">Être recontacté</h3>
      <p className="text-sm text-slate-500 mt-1">Laissez vos coordonnées — conservées de façon chiffrée et confidentielle.</p>
      <div className="mt-4 space-y-3">
        <Input data-testid="lead-prenom" placeholder="Prénom" value={form.prenom} onChange={(e) => setForm({ ...form, prenom: e.target.value })} className="rounded-xl" />
        <Input data-testid="lead-courriel" type="email" placeholder="Courriel" value={form.courriel} onChange={(e) => setForm({ ...form, courriel: e.target.value })} className="rounded-xl" />
        <Input data-testid="lead-telephone" placeholder="Téléphone" value={form.telephone} onChange={(e) => setForm({ ...form, telephone: e.target.value })} className="rounded-xl" />
      </div>
      <label className="mt-4 flex items-start gap-3 cursor-pointer">
        <Checkbox data-testid="lead-consent" checked={consent} onCheckedChange={(v) => setConsent(!!v)} className="mt-0.5" />
        <span className="text-xs text-slate-500 leading-relaxed">{CONSENT_TEXT}</span>
      </label>
      <button data-testid="lead-submit" type="submit" disabled={sending} className="mt-4 w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-[#C89A3E] text-[#012141] font-bold hover:brightness-95 disabled:opacity-60 transition-all">
        {sending ? <Loader2 className="animate-spin" size={18} /> : <Lock size={16} />} Envoyer en toute sécurité
      </button>
    </form>
  );
};
